module.exports = __webpack_public_path__ + "static/media/techno-4.7a111022.png";